import { StrictMode, useState } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import UploadPage from './pages/Upload';
import Login from './pages/Login';
import { clearSession, getToken, getUser, isJwtExpired, type AuthUser } from './auth';
import './styles.css';

const rootEl = document.getElementById('root');
if (!rootEl) throw new Error('Missing #root element');

function initialUser(): AuthUser | null {
  const token = getToken();
  if (!token || isJwtExpired(token)) {
    clearSession();
    return null;
  }
  return getUser();
}

function Root() {
  const [user, setUser] = useState<AuthUser | null>(() => initialUser());

  if (!user) {
    return <Login onAuthed={setUser} />;
  }

  const path = window.location.pathname;
  const handleSignOut = () => {
    clearSession();
    setUser(null);
  };

  if (path === '/upload') {
    return <UploadPage onSignOut={handleSignOut} />;
  }
  return <App user={user} onSignOut={handleSignOut} />;
}

createRoot(rootEl).render(
  <StrictMode>
    <Root />
  </StrictMode>,
);
